import Vue from 'vue'
import Router from 'vue-router'
import store from "../store";
import userInfo from '../request/api'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
 // 白名单
import constRouters from "./constRouter";
function exportWhiteListFromRouter(router){
  let res = []
  for(let item of router)
    res.push(item.path)
  return res
}
const whiteList = exportWhiteListFromRouter(constRouters)

import courseRouter from "./modules/course";
import taskRouter from "./modules/task";
import materialRouter from "./modules/material";
import foundRouter from "./modules/found";
import partner from './modules/partner'
import answer from './modules/answer'
export const constantRouterMap = [
  {
    path: '/',
    // component: () => import('../pages/index')
    component: () => import('../pages/index')
  },
  courseRouter,
  taskRouter,
  materialRouter,
  foundRouter,
  partner,
  answer,
  {
    path: '/active/list',
    component: () => import('../views/activity/index'),
    name: 'active_list'
  },
  //活动详情
  {
    path: '/active/detail',
    component: () => import('../views/activity/detail'),
    name: 'active_detail'
  },
  //报名
  {
    path: '/active/sing',
    component: () => import('../views/activity/sing'),
    name: 'active_sing'
  },
  //报名
  {
    path: '/active/diyform',
    component: () => import('../views/activity/diyform'),
    name: 'active_diyform'
  },
  //上传参赛作品
  {
    path: '/active/entry',
    component: () => import('../views/activity/entry'),
    name: 'active_entry'
  },
  //大赛作品列表
  {
    path: '/active/works',
    component: () => import('../views/activity/works'),
    name: 'active_works'
  },
  //获奖公示
  {
    path: '/active/notice',
    component: () => import('../views/activity/notice'),
    name: 'active_notice'
  },
  //大赛作品详情
  {
    path: '/active/workDetail',
    component: () => import('../views/activity/workDetail'),
    name: 'active_work_detail'
  },
  //个人大赛作品修改
  {
    path: '/personal/competition/edit',
    component: () => import('../views/personal/competition/edit'),
    name: 'competition_edit'
  },

  {
    path: '/vip',
    component: () => import('../views/vip/index'),
    name:'vip',
  },
  {
    path: '/teacher/home',
    component: () => import('../pages/teacher/index'),
    name: 'teacher_home'
  },
  {
    path: '/teacher/propaganda',
    component: () => import('../components/teacherPropaganda/index'),
    name: 'teacher_propaganda'
  },
  {
    path: '/wx_url',
    component: () => import('../components/wx'),
    name: 'wx_url'
  },
  {
    path: '/inside_video',
    component: () => import('../components/video/inside/index'),
    name: 'inside_video'
  },
  {
    path: '/personal',
    component: () => import('../views/personal/index'),
    name:'personal',
  },
  {
    path: '/account/setting',
    component: () => import('../views/setting/index'),
    name:'account_setting',
  },
  {
    path: '/message',
    component: () => import('../views/message/index'),
    name:'message',
  },
  {
    path: '/single/page',
    component: () => import('../pages/page'),
    name:'single_page',
  },
  // 设计师主页
  {
    path: '/designer/detail',
    component: () => import('../pages/designer/index'),
    name:'designer_detail',
  },
  // 教师列表
  {
    path: '/teacher/list',
    component: () => import('../views/teacher/index'),
    name: 'teacher_list'
  },
  // 诸葛榜
  {
    path: '/recommend/designer',
    component: () => import('../views/recommend/index'),
    name:'designer_recommend',
  },
  // 企业主页
  {
    path: '/company/detail',
    component: () => import('../pages/enterprise/index'),
    name:'enterprise_detail',
  },
  // 搜索
  {
    path: '/search',
    component: () => import('../pages/search'),
    name:'search_detail',
  },
  // 意见反馈
  {
    path: '/feedback',
    component: () => import('../pages/feedback'),
    name:'feedback_detail',
  },
  // 404
  {
    path: '*',
    component: () => import('../pages/404'),
    name:'Page404',
  },
  // 500
  {
    path: '/500',
    component: () => import('../pages/500'),
    name:'Page500',
  },
]
const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
const router = createRouter()
router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('Authorization')
  if (!token) {
    whiteList.indexOf(to.path) !==-1 ? next() : (store.state.status.login=true,next(`/`))
  } else {
    userInfo.userInfo().then(res => {
      localStorage.setItem('user-info', JSON.stringify(res.data))
      store.state.status.message_count = res.data.notification_count
      Vue.prototype.$Bus.$emit("upload_avatar",res.data)
    })
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js